// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__uMp0a","label":"Radio_label__2iy5w","checkMark":"Radio_checkMark__5c0zs","disabled":"Radio_disabled__Mz7wd"};